import { RichiestaDTO } from '@framework/api-client';
import * as React from 'react';

export interface IFillableSubmissionContext {
  submissionId?: string | null;
  submission?: RichiestaDTO | null;
  /** ID richiesta-modulo */
  submissionModuleId?: string | null;
}

const FillableSubmissionContext =
  React.createContext<IFillableSubmissionContext>({});

export interface IFillableSubmissionContextProviderProps {
  submission?: RichiestaDTO | null;
  submissionModuleId?: string | null;
  children: React.ReactNode;
}

/**
 * Permette di definire il contesto di una Richiesta per il motore di
 * compilazione.
 * Usato per esempio per le Competenze.
 */
export function FillableSubmissionContextProvider(
  props: IFillableSubmissionContextProviderProps,
) {
  const values = React.useMemo(() => {
    return {
      submission: props.submission,
      submissionId: props.submission?.id,
      submissionModuleId: props.submissionModuleId,
    };
  }, [props.submission, props.submissionModuleId]);

  return (
    <FillableSubmissionContext.Provider value={values}>
      {props.children}
    </FillableSubmissionContext.Provider>
  );
}

export function useFillableSubmissionContext() {
  const context = React.useContext(FillableSubmissionContext);
  if (!context) {
    console.warn(
      'useFillableSubmissionContext deve essere usato in un FillableSubmissionContextProvider',
    );
  }
  return context;
}
